import { Form, Popup } from "devextreme-react";
import {
  ButtonItem,
  CompareRule,
  FormRef,
  Label,
  RequiredRule,
  SimpleItem,
} from "devextreme-react/form";
import notify from "../../lib/notify";
import { FormEvent, useCallback, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "../../lib/axios";

type ChangeUserPasswordPopupProps = {
  userId: number;
  onClose: (passwordChanged: boolean) => void;
};

export default function ChangeUserPasswordPopup({
  userId,
  onClose,
}: ChangeUserPasswordPopupProps) {
  const { t } = useTranslation();
  const formRef = useRef<FormRef>(null);
  const [formDisabled, setFormDisabled] = useState(false);

  const handleSubmit = useCallback(
    async (event: FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      const formData = formRef.current?.instance().option("formData");

      setFormDisabled(true);

      try {
        await axios.post("/api/auth/change-password-by-administrator", {
          userId,
          password: formData.password,
        });

        onClose(true);
      } catch (error) {
        notify(
          "Wystąpił błąd podczas próby zmiany hasła do konta użytkownika.",
          "error"
        );
      } finally {
        setFormDisabled(false);
      }
    },
    [userId, onClose]
  );

  return (
    <Popup
      visible
      title={t("changeUserPasswordPopup.title")}
      onHiding={() => onClose(false)}
      maxWidth={500}
      height="auto"
      maxHeight="80vh"
      showCloseButton
      dragEnabled
    >
      <form onSubmit={handleSubmit}>
        <Form
          ref={formRef}
          defaultFormData={{
            password: "",
            passwordConfirmation: "",
          }}
          disabled={formDisabled}
        >
          <SimpleItem dataField="password" editorOptions={{ mode: "password" }}>
            <Label text={t("changeUserPasswordPopup.newPassword")} />
            <RequiredRule />
          </SimpleItem>
          <SimpleItem
            dataField="passwordConfirmation"
            editorOptions={{ mode: "password" }}
          >
            <Label text={t("changeUserPasswordPopup.passwordConfirmation")} />
            <RequiredRule />
            <CompareRule
              comparisonTarget={() =>
                formRef.current?.instance().option("formData").password
              }
            />
          </SimpleItem>
          <ButtonItem
            buttonOptions={{
              useSubmitBehavior: true,
              type: "default",
              text: t("changeUserPasswordPopup.changePassword"),
            }}
          />
        </Form>
      </form>
    </Popup>
  );
}
